// 导入所有 admin 模块的国际化文件
import { messages as deleteProductMessages } from '@/lang/admin/deleteProductLang.js'
import { messages as userIntegralMessages } from '@/lang/admin/userIntegralLang.js'
import { messages as systemGoldSettingMessages } from '@/lang/admin/systemGoldSettingLang.js'
import { messages as storeOrderCartManageMessages } from '@/lang/admin/storeOrderCartManageLang.js'
import { messages as storeIntegralMessages } from '@/lang/admin/storeIntegralLang.js'
import { messages as shopTypeMessages } from '@/lang/admin/shopTypeLang.js'
import { messages as shopProductTypeMessages } from '@/lang/admin/shopProductTypeLang.js'
import { messages as shopCommunityMessages } from '@/lang/admin/shopCommunityLang.js'
import { messages as merchantShopMessages } from '@/lang/admin/merchantShopLang.js'
import { messages as deleteMerchantMessages } from '@/lang/admin/deleteMerchantLang.js'
import { messages as updateStoreStateMessages } from '@/lang/admin/updateStoreStateLang.js'
import { messages as addMerchantShopMessages } from '@/lang/admin/addMerchantShopLang.js'
import { messages as merchantManageMessages } from '@/lang/admin/merchantManageLang.js'
import { messages as mainCategoryProductMessages } from '@/lang/admin/mainCategoryProductLang.js'
import { messages as mainCategoryMessages } from '@/lang/admin/mainCategoryLang.js'
import { messages as integralWithdrawalMessages } from '@/lang/admin/integralWithdrawalLang.js'
import { messages as integralSettingMessages } from '@/lang/admin/integralSettingLang.js'
import { messages as integralDetailMessages } from '@/lang/admin/integralDetailLang.js'
import { messages as housekeepingTypeMessages } from '@/lang/admin/housekeepingTypeLang.js'
import { messages as goldWithdrawalMessages } from '@/lang/admin/goldWithdrawalLang.js'
import { messages as goldDetailMessages } from '@/lang/admin/goldDetailLang.js'
import { messages as goldBuyCartManageMessages } from '@/lang/admin/goldBuyCartManageLang.js'
import { messages as goldMessages } from '@/lang/admin/goldLang.js'
import { messages as chainProductMessages } from '@/lang/admin/chainProductLang.js'
import { messages as chainSupplierCatalogMessages } from '@/lang/admin/chainSupplierCatalogLang.js'
import { messages as chainSupplierMessages } from '@/lang/admin/chainSupplierLang.js'
import { messages as chainInoutOrderMessages } from '@/lang/admin/chainInoutOrderLang.js'
import { messages as auditShopCommunityMessages } from '@/lang/admin/auditShopCommunityLang.js'
import { messages as auditOpenShopMessages } from '@/lang/admin/auditOpenShopLang.js'
import { messages as applyGoldWithdrawalMessages } from '@/lang/admin/applyGoldWithdrawalLang.js'
import { messages as adminServMessages } from '@/lang/admin/adminServLang.js'
import { messages as deleteAdminServMessages } from '@/lang/admin/deleteAdminServLang.js'
import { messages as refundCartMessages } from '@/lang/admin/refundCartLang.js'
import { messages as accountWithdrawalApplyMessages } from '@/lang/admin/accountWithdrawalApplyLang.js'
import { messages as accountWithdrawalApplyFkManageMessages } from '@/lang/admin/accountWithdrawalApplyFkManageLang.js'
import { messages as accountWithdrawalApplyShManageMessages } from '@/lang/admin/accountWithdrawalApplyShManageLang.js'
import { messages as accountBondObjDetailMessages } from '@/lang/admin/accountBondObjDetailLang.js'
import { messages as accountBondMessages } from '@/lang/admin/accountBondLang.js'

import { messages as rechargeSettingMessages } from '@/lang/admin/rechargeSettingLang.js'


// 合并所有国际化消息
export const messages = {
    en: {
        ...deleteProductMessages.en,
        ...userIntegralMessages.en,
        ...systemGoldSettingMessages.en,
        ...storeOrderCartManageMessages.en,
        ...storeIntegralMessages.en,
        ...shopTypeMessages.en,
        ...shopProductTypeMessages.en,
        ...shopCommunityMessages.en,
        ...merchantShopMessages.en,
        ...deleteMerchantMessages.en,
        ...updateStoreStateMessages.en,
        ...addMerchantShopMessages.en,
        ...merchantManageMessages.en,
        ...mainCategoryProductMessages.en,
        ...mainCategoryMessages.en,
        ...integralWithdrawalMessages.en,
        ...integralSettingMessages.en,
        ...integralDetailMessages.en,
        ...housekeepingTypeMessages.en,
        ...goldWithdrawalMessages.en,
        ...goldDetailMessages.en,
        ...goldBuyCartManageMessages.en,
        ...goldMessages.en,
        ...chainProductMessages.en,
        ...chainSupplierCatalogMessages.en,
        ...chainSupplierMessages.en,
        ...chainInoutOrderMessages.en,
        ...auditShopCommunityMessages.en,
        ...auditOpenShopMessages.en,
        ...applyGoldWithdrawalMessages.en,
        ...adminServMessages.en,
        ...deleteAdminServMessages.en,
        ...refundCartMessages.en,
        ...accountWithdrawalApplyMessages.en,
        ...accountWithdrawalApplyFkManageMessages.en,
        ...accountWithdrawalApplyShManageMessages.en,
        ...accountBondObjDetailMessages.en,
        ...accountBondMessages.en,
        ...rechargeSettingMessages.en
    },
    zh: {
        ...deleteProductMessages.zh,
        ...userIntegralMessages.zh,
        ...systemGoldSettingMessages.zh,
        ...storeOrderCartManageMessages.zh,
        ...storeIntegralMessages.zh,
        ...shopTypeMessages.zh,
        ...shopProductTypeMessages.zh,
        ...shopCommunityMessages.zh,
        ...merchantShopMessages.zh,
        ...deleteMerchantMessages.zh,
        ...updateStoreStateMessages.zh,
        ...addMerchantShopMessages.zh,
        ...merchantManageMessages.zh,
        ...mainCategoryProductMessages.zh,
        ...mainCategoryMessages.zh,
        ...integralWithdrawalMessages.zh,
        ...integralSettingMessages.zh,
        ...integralDetailMessages.zh,
        ...housekeepingTypeMessages.zh,
        ...goldWithdrawalMessages.zh,
        ...goldDetailMessages.zh,
        ...goldBuyCartManageMessages.zh,
        ...goldMessages.zh,
        ...chainProductMessages.zh,
        ...chainSupplierCatalogMessages.zh,
        ...chainSupplierMessages.zh,
        ...chainInoutOrderMessages.zh,
        ...auditShopCommunityMessages.zh,
        ...auditOpenShopMessages.zh,
        ...applyGoldWithdrawalMessages.zh,
        ...adminServMessages.zh,
        ...deleteAdminServMessages.zh,
        ...refundCartMessages.zh,
        ...accountWithdrawalApplyMessages.zh,
        ...accountWithdrawalApplyFkManageMessages.zh,
        ...accountWithdrawalApplyShManageMessages.zh,
        ...accountBondObjDetailMessages.zh,
        ...accountBondMessages.zh,
        ...rechargeSettingMessages.zh

    }
}
